import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ViewVirtualWeightComponent } from "./virtual_weight/virtual_weight";
import { ContentViewDeviceComponent } from "./content";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SpeedViewFeederComponent } from "./speed/speed";
import { SensorsValueComponent } from "./sensors_value/sensors_value";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { VirtualWeightModule } from "../virtual_weight/virtual_weight.module";
import { LoadingModule } from "../loading/loading.module";
import { TranslateModule } from "@ngx-translate/core";
import { ImageColorModule } from "../image_color/image_color.module";
import { EchartModule } from "../echart/echart.module";
import { SettingFeedersModule } from "../settings-feeders/settings-feeders.module";
import { ConfigSensorsDeviceModule } from "../config_sensors_device/config_sensors_device.module";
import { FrameDeviceDynamicModule } from "../frames_device_dynamic/frame_device.module";
import { RouterModule } from "@angular/router";

@NgModule({
  imports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    VirtualWeightModule,
    LoadingModule,
    TranslateModule,
    ImageColorModule,
    EchartModule,
    SettingFeedersModule,
    ConfigSensorsDeviceModule,
    FrameDeviceDynamicModule,
    RouterModule
  ],
  providers: [
    ContentViewDeviceComponent,
    ViewVirtualWeightComponent,
    SpeedViewFeederComponent,
    SensorsValueComponent
  ],
  declarations: [
    ContentViewDeviceComponent,
    ViewVirtualWeightComponent,
    SpeedViewFeederComponent,
    SensorsValueComponent
  ],
  exports: [
    ContentViewDeviceComponent,
    ViewVirtualWeightComponent,
    SpeedViewFeederComponent,
    SensorsValueComponent
  ]
})
export class ViewContentDeviceModule {}
